import { render, staticRenderFns } from "./monday-onboarding-edit.page.vue?vue&type=template&id=86ef5884&scoped=true&"
import script from "./monday-onboarding-edit.page.vue?vue&type=script&lang=js&"
export * from "./monday-onboarding-edit.page.vue?vue&type=script&lang=js&"
import style0 from "./monday-onboarding-edit.page.vue?vue&type=style&index=0&id=86ef5884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ef5884",
  null
  
)

export default component.exports